export default __webpack_public_path__ + "src/appV2/redesign/WorkerShifts/ShiftDetails/components/CancellationProtection/assets/images/parachute.png";